export type PostJobQueryOpening = {
  id: string;
};

/**
 * True when Hire asks source-ui to drop a stale posting session and start on
 * select-openings (`/post-job?fresh=1`).
 */
export function isPostJobFreshStart(search: string): boolean {
  return new URLSearchParams(search).get('fresh') === '1';
}

/**
 * Parses `/post-job?openingIds=…` for deep links from Hire.
 * Supports a single opening (primary Hire entry) or comma-separated lists.
 * Opening titles are loaded by source-ui after seed.
 */
export function parsePostJobQuery(
  search: string,
): PostJobQueryOpening[] | null {
  const params = new URLSearchParams(search);
  const openingIdsParam = params.get('openingIds');
  if (!openingIdsParam) {
    return null;
  }

  const ids = openingIdsParam
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
  if (ids.length === 0) {
    return null;
  }

  return ids.map(id => ({ id }));
}
